{
  "name": "saleshubapp",
  "version": "0.1",
  "private": true,
  "description": "SalesHub App",
  "author": "A EINS Business Intelligence GmbH",
  "homepage": "https://aeins.de",
  "scripts": {
    "generate-imports": "generate_widgets_map",
    "generate-env-file": "generate_env kv-saleshub-dev b434a068-0070-43b1-9874-a2be3b091b36",
    "generate-env-file:dev": "generate_env kv-saleshub-dev b434a068-0070-43b1-9874-a2be3b091b36",
    "generate-env-file:staging": "generate_env kv-saleshub-staging b434a068-0070-43b1-9874-a2be3b091b36",
    "generate-env-file:prod": "generate_env kv-saleshub-live b434a068-0070-43b1-9874-a2be3b091b36",
    "prepare-env": "npm run generate-imports && npm run generate-env-file",
    "build:dev": "ionic build",
    "build:staging": "ionic build --configuration staging",
    "build:prod": "ionic build --configuration production",
    "test": "ng test",
    "test-server": "export NODE_OPTIONS=\"--max-old-space-size=4096\" && ng test --karma-config=karma_server.conf.js --watch=false --code-coverage",
    "coverage": "ng test --code-coverage=true",
    "lint": "ng lint",
    "lint-styles": "npx stylelint \"**/*.css\"",
    "git-config": "git config --local core.hooksPath .githooks/",
    "g-shared-frontend-api": "generate_api shared-frontend-api.config.json",
    "prepare-native:android": "npx cap sync android && prepare_native",
    "prepare-native:ios": "npx cap sync ios && prepare_native"
  },
  "dependencies": {
    "@aeins/cli": "^1.3.9",
    "@aeins/components": "2.4.1",
    "@aeins/core": "2.5.1",
    "@aeins/sharedfrontendapi": "2026.831.1608",
    "@angular/animations": "22.1.4",
    "@angular/cdk": "22.1.4",
    "@angular/common": "22.1.4",
    "@angular/core": "22.1.4",
    "@angular/fire": "20.0.1",
    "@angular/forms": "22.1.4",
    "@angular/localize": "22.1.4",
    "@angular/platform-browser": "22.1.4",
    "@angular/platform-browser-dynamic": "22.1.4",
    "@angular/pwa": "22.1.6",
    "@angular/router": "22.1.4",
    "@angular/service-worker": "22.1.4",
    "@aparajita/capacitor-secure-storage": "8.0.0",
    "@capacitor-a1/google-maps": "8.0.1-a1.4",
    "@capacitor-aeins/intercom": "7.0.4-a1.46",
    "@capacitor-aeins/location-state": "6.0.0",
    "@capacitor/app": "8.1.1",
    "@capacitor/browser": "8.0.4",
    "@capacitor/core": "8.5.1",
    "@capacitor/geolocation": "8.2.2",
    "@capacitor/local-notifications": "8.3.1",
    "@capacitor/network": "8.0.1",
    "@capacitor/preferences": "8.0.1",
    "@capacitor/splash-screen": "8.0.2",
    "@capacitor/status-bar": "8.0.3",
    "@capawesome/capacitor-android-dark-mode-support": "8.0.1",
    "@googlemaps/js-api-loader": "2.1.1",
    "@googlemaps/markerclusterer": "2.6.2",
    "@intercom/messenger-js-sdk": "0.0.20",
    "@ionic/angular": "9.0.1",
    "@ionic/core": "9.0.1",
    "@logto/angular": "1.0.4",
    "@logto/browser": "3.0.13",
    "@logto/js": "6.1.2",
    "@maskito/angular": "5.4.0",
    "@maskito/core": "5.4.0",
    "@meddv/ngx-pinch-zoom": "20.0.0",
    "@messageformat/core": "3.4.0",
    "@microsoft/signalr": "10.0.11",
    "@ngrx/operators": "22.0.0",
    "@ngrx/signals": "22.0.0",
    "@ngrx/store": "22.0.0",
    "@ngx-translate/core": "18.0.0",
    "@openng/optimus-ui": "2.0.2",
    "@openng/optimus-ui-themes": "2.0.2",
    "angular-auth-oidc-client": "22.0.0",
    "c15t": "2.2.1",
    "capacitor-areas": "7.0.0",
    "capacitor-native-settings": "8.2.0",
    "color": "5.0.3",
    "date-fns": "4.4.0",
    "i18n-iso-countries": "7.14.0",
    "libphonenumber-js": "1.13.12",
    "linqts": "3.3.0",
    "lodash": "4.18.1",
    "mathjs": "15.2.0",
    "ngx-image-compress": "18.1.7",
    "ngx-translate-messageformat-compiler": "7.3.0",
    "onesignal-cordova-plugin": "5.5.3",
    "onesignal-ngx": "2.4.4",
    "rxjs": "7.8.2",
    "scroll-snap-api": "1.0.2",
    "semver": "7.8.5",
    "swiper": "14.2.0",
    "tslib": "2.8.1",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.2.0",
    "@angular-eslint/eslint-plugin": "22.2.0",
    "@angular-eslint/eslint-plugin-template": "22.2.0",
    "@angular-eslint/schematics": "22.2.0",
    "@angular-eslint/template-parser": "22.2.0",
    "@angular/cli": "22.1.6",
    "@capacitor/cli": "8.5.1",
    "@eslint/js": "10.0.1",
    "@ionic/angular-toolkit": "13.0.0",
    "@ionic/cli": "7.2.1",
    "@ngx-env/builder": "22.0.0",
    "@tailwindcss/postcss": "4.3.3",
    "@trapezedev/project": "7.1.10",
    "@types/estree": "1.0.9",
    "@types/jasmine": "6.0.0",
    "@types/jasminewd2": "2.0.13",
    "@types/lodash": "4.17.25",
    "@types/node": "26.4.0",
    "@typescript-eslint/eslint-plugin": "8.69.0",
    "@typescript-eslint/parser": "8.69.0",
    "angular-eslint": "22.2.0",
    "autoprefixer": "10.5.4",
    "browserslist": "4.28.8",
    "cross-env": "10.1.0",
    "dotenv": "17.4.2",
    "eslint": "10.9.1",
    "eslint-config-standard": "17.1.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-node": "11.1.0",
    "eslint-plugin-promise": "7.3.0",
    "eslint-plugin-rxjs": "5.0.3",
    "eslint-plugin-simple-import-sort": "14.0.0",
    "eslint-plugin-unused-imports": "4.4.1",
    "jasmine-core": "7.0.2",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-firefox-launcher": "2.1.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.3.0",
    "karma-junit-reporter": "2.0.1",
    "karma-spec-reporter": "0.0.36",
    "ng-mocks": "14.17.3",
    "ng-packagr": "22.1.1",
    "postcss": "8.5.26",
    "prettier": "3.9.6",
    "prettier-plugin-tailwindcss": "0.8.1",
    "stylelint": "17.14.1",
    "stylelint-config-standard": "40.0.0",
    "tailwindcss": "4.3.3",
    "ts-node": "10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "8.69.0"
  },
  "browserslist": [
    "defaults"
  ],
  "packageManager": "pnpm@11.27.1+sha512.a81d4c21b9b09a4b0aebf90ef5e527d4262bdda322d26082978cb549023ac6d9cafc98b19fffaa5c71db438a65f70224edb78d7311187861ff96480d1cdca23c"
}
